"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _spin = _interopRequireDefault(require("../../../../node_modules/spin.js/spin"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Loader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Loader, _Component);

  var _super = _createSuper(Loader);

  function Loader() {
    (0, _classCallCheck2.default)(this, Loader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Loader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var loader = document.querySelector('.full-page-loader');
      var spinnerOptions = {
        lines: 10,
        // The number of lines to draw
        length: 10,
        // The length of each line
        width: 3,
        // The line thickness
        radius: 13,
        // The radius of the inner circle
        corners: 1,
        // Corner roundness (0..1)
        rotate: 0,
        // The rotation offset
        direction: 1,
        // 1: clockwise, -1: counterclockwise
        color: '#000',
        // #rgb or #rrggbb or array of colors
        speed: 1,
        // Rounds per second
        trail: 60,
        // Afterglow percentage
        shadow: false,
        // Whether to render a shadow
        hwaccel: false,
        // Whether to use hardware acceleration
        className: 'spinner',
        // The CSS class to assign to the spinner
        zIndex: 2e9,
        // The z-index (defaults to 2000000000)
        top: '50%',
        // Top position relative to parent
        left: '50%' // Left position relative to parent

      };
      var spinner = new _spin.default(spinnerOptions);
      spinner.spin(loader);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)("div", {
        className: "full-page-loader-background"
      }, (0, _preact.h)("div", {
        className: "full-page-loader"
      }));
    }
  }]);
  return Loader;
}(_preact.Component);

var _default = Loader;
exports.default = _default;